/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/**
 * Reconstructs full-width values from the wrapping counters FIT stores.
 *
 * A field flagged *accumulated* is written as the low N bits of a monotonically
 * increasing quantity (total cycles, total distance). Each new sample is the
 * previous one plus the wrapped delta, so the true value is recovered by summing
 * deltas rather than reading the sample directly.
 */
public class Accumulator {
    // mesgNum -> fieldNum -> running total
    private val fields = HashMap<Int, HashMap<Int, AccumulatedField>>()

    public fun create(mesgNum: UShort, fieldNum: UByte, value: Long): AccumulatedField {
        val field = AccumulatedField(value)
        fields.getOrPut(mesgNum.toInt()) { HashMap() }[fieldNum.toInt()] = field
        return field
    }

    public fun accumulate(mesgNum: UShort, fieldNum: UByte, value: Long, bits: Int): Long {
        val existing = fields[mesgNum.toInt()]?.get(fieldNum.toInt())
        if (existing != null) return existing.accumulate(value, bits)
        return create(mesgNum, fieldNum, value).accumulate(value, bits)
    }

    public class AccumulatedField internal constructor(initialValue: Long) {
        private var accumulatedValue: Long = initialValue
        private var lastValue: Long = initialValue

        internal fun accumulate(value: Long, bits: Int): Long {
            val mask = if (bits >= 64) -1L else (1L shl bits) - 1L
            accumulatedValue += (value - lastValue) and mask
            lastValue = value
            return accumulatedValue
        }
    }
}
